import axios, { createBaseURL } from '@/utils/axios';
/*

    주문접수 API set 입니다.

*/

export function useOutbound() {
  // 택배 주문접수를 합니다.
  const registerParcel = async (payload: api.outbound.parcel.payload) => {
    try {
      let registerParcelUrl = '/outbound/parcel';

      if (payload.outboundParcels[0].parcelCategory?._id) {
        registerParcelUrl = registerParcelUrl + '?v=2';
      }

      const { data } = await axios.post<api.outbound.parcel.response>('outbound/parcel', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };
  // 퀵 - 오토바이 주문 접수
  const registerQuick = async (payload: api.outbound.quick.payload) => {
    try {
      const { data } = await axios.post<api.outbound.quick.response>('outbound/quick', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };
  // 퀵 - 화물 주문 접수
  const registerFreightQuick = async (payload: api.outbound.freightPayload) => {
    try {
      const { data } = await axios.post<api.outbound.quick.response>('outbound/freight-quick', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  // 번들번호 기반 주문 목록을 조회 합니다.
  const getBundleList = async (payload: api.outbound.bundle.payload) => {
    try {
      const { data } = await axios.post(`/v3/outbound/bundles?page=${payload.page}&perPage=${payload.perPage}`, {
        q: payload.q,
        bundleType: payload.bundleType,
      });
      if (data.result !== 'SUCCESS') throw data.error;
      return data.data;
    } catch (e) {
      throw e;
    }
  };

  // 번들 하위 패키지 목록을 조회합니다.
  const getPackageList = async (bundleId: string) => {
    try {
      const { data } = await axios.get<api.outbound.package.response>(`outbound/packages/${bundleId}`);

      return data;
    } catch (e) {
      throw e;
    }
  };

  // 패키지 부분취소
  const cancelPartPackage = async (payload: api.outbound.cancel.package.payload) => {
    try {
      const { data } = await axios.post<api.outbound.cancel.package.response>('outbound/part/cancel', payload);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  const excelExport = async (payload: api.outbound.exportExcel.payload) => {
    try {
      const { data } = await axios.get<api.outbound.exportExcel.response>(
        `outbound/export?from=${payload.from}&to=${payload.to}`
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  const $getBundleNumber = async (category: 'quick' | 'parcel' | 'expressMail' | 'registeredMail' | 'ems' | 'dhl') => {
    try {
      const { data } = await axios.get<api.outbound.getBundle.response>(`outbound/bundle-number?category=${category}`);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  // 거래명세서 다운로드용 번들 하위 패키지 목록을 조회합니다.
  const getExportPackageList = async (payload: api.outbound.package.payload) => {
    try {
      const { data } = await axios.get<api.outbound.package.response>(`outbound/export/${payload}`);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  // 다건/다량 등기 접수(다건식으로 통합)
  const registerMail = async (payload: api.outbound.registry.massMailPayload) => {
    try {
      const { data } = await axios.post<api.outbound.registry.response>('/outbound/mail', payload);
      if (!data.success) throw data;
      return data;
    } catch (error) {
      throw error;
    }
  };

  // 퀵 - 라이더 위치 조회 웹뷰 url을 조회합니다.
  const getQuickRiderLocationUrl = async (packageId: string) => {
    try {
      const { data } = await axios.get<api.outbound.quick.riderLocation>(
        `/packages/outbound/quick/${packageId}/rider-location `
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  // 주문내역조회 - 퀵서비스 요금상세 조회 팝업(일반퀵,화물)
  const getQuickBillDetail = async (chargeId: string) => {
    try {
      const { data } = await axios.get<api.outbound.quick.quickBillDetail>(`/charge/${chargeId}/quick`);
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  const getAvailablePaymentMethodList = async (payload: {
    serviceType: outbound.ServiceType;
    customerDropOffMethod: outbound.itemDeliveryMethod;
  }) => {
    try {
      const { data } = await axios.post<api.outbound.availablePaymentInfo>('/available-payment-methods', payload);
      if (data.result !== 'SUCCESS') throw data.error;
      return data.data;
    } catch (e) {
      throw e;
    }
  };

  return {
    registerParcel,
    registerQuick,
    registerFreightQuick,
    getBundleList,
    getPackageList,
    cancelPartPackage,
    excelExport,
    $getBundleNumber,
    getExportPackageList,
    registerMail,
    getQuickRiderLocationUrl,
    getQuickBillDetail,
    getAvailablePaymentMethodList,
  };
}
